import { useEffect, useState } from 'react';
import { DataSyncObjectsStore } from '../stores/object/DataSyncObjectsStore';

export function useFetchStores(
  sourceStore: DataSyncObjectsStore | null,
  destinationStore: DataSyncObjectsStore | null
) {
  const [sourceLoaded, setSourceLoaded] = useState(false);
  const [destinationLoaded, setDestinationLoaded] = useState(false);

  useEffect(() => {
    if (sourceStore) {
      setSourceLoaded(false); // Reset when store changes
      sourceStore.fetch()
        .then(() => {
          setSourceLoaded(true);
        });
    } else {
      // Mark as loaded if no store (either unavailable or not needed)
      setSourceLoaded(true);
    }
  }, [sourceStore]);

  useEffect(() => {
    if (destinationStore) {
      setDestinationLoaded(false); // Reset when store changes
      destinationStore.fetch()
        .then(() => {
          setDestinationLoaded(true);
        });
    } else {
      // Mark as loaded if no store (either unavailable or not needed)
      setDestinationLoaded(true);
    }
  }, [destinationStore]);

  return {loaded: sourceLoaded && destinationLoaded};
}
